






import { Component, Vue, Emit, Prop } from 'vue-property-decorator';

@Component({
  components: {

  }
})
export default class extends Vue {

  @Prop()
  public value: any;

}
